import sliderconsts from './slider/slider-data';
export default function sliderConsts(app) {
	app.constant("SLIDER_CONSTS", sliderconsts);
}
